import * as types from './type';

import { Location }  from  '../../services/location';

export function getAutocompleteLocation(post) {
    return {
      type: types.GET_AUTOCOMPLETE_LOCATION,
      payload: Location.getAutocompleteLocation(post),
    };
};

